import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppliedTermsService {
  protected endpoint: string;

  constructor(private apiService: ApiService) {
    this.endpoint = 'rate-manager/provider/applied-terms';
  }

  private cleanPayload(rawPayload: any) {
    return Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, v]) => v !== null && v !== undefined
      )
    );
  }

  getAppliedTerms(payload: Record<string, any> = {}) {
    const cleanedPayload = this.cleanPayload(payload);
    return this.apiService.get(this.endpoint, cleanedPayload, true);
  }

  async createAppliedTerm(payload: Record<string, any>) {
    const cleanedPayload = this.cleanPayload(payload);
    const response: any = await firstValueFrom(
      this.apiService.post(this.endpoint, cleanedPayload)
    );
    return response;
  }

  async updateAppliedTerm(id: number, payload: Record<string, any>) {
    const cleanedPayload = this.cleanPayload(payload);
    const response: any = await firstValueFrom(
      this.apiService.put(`${this.endpoint}/${id}`, cleanedPayload)
    );
    return response;
  }

  async deleteAppliedTerm(id: number) {
    const response: any = await firstValueFrom(
      this.apiService.delete(`${this.endpoint}/${id}`, {}, true)
    );
    return response;
  }
}
